import { useState } from "react";
import { PortableTextBlock } from "sanity";
import Button from "src/components/button/Button";
import MainText from "src/components/richtext/MainText";
import styles from './ArticleSummary.module.css';
import classNames from 'classnames';

// #region [Props]
type ArticleSummaryProps = {
  summary?: PortableTextBlock[];
  className?: string;
};
// #endregion

// #region [Component]
export default function ArticleSummary({ summary, className }: ArticleSummaryProps) {
  const [showAll, setShowAll] = useState(false);
  if ((summary?.length ?? 0) === 0) {
    return null;
  }
  return (
    <div className={classNames(styles.SArticleSummary, className)}>
      <div className={styles.SContainer}>
        <h2 className={styles.SSummaryHeading}>Oppsummering av saken</h2>
        <div className={styles.SSummaryList}>
          <MainText mainText={summary} className={classNames(styles.SMainText, { [styles.showAll]: showAll })} />
        </div>
        {!showAll && summary!.length > 1 && (
          <Button className={styles.SSummaryButton} text="Vis mer" isLarge onClick={() => setShowAll(true)} />
        )}
      </div>
    </div>
  );
}
// #endregion

